import {
  crashBustProvocation,
  crashProvocation,
} from "@karrtopelka/cards/provocations";
import type { CardProps } from "@karrtopelka/cards/types";
import type { CrashResult } from "@karrtopelka/game-kit";

const RANKLINE_MIN_TOTAL = 10;

/** Build the result card from a resolved crash round. Win shows the multiplier; a crash
 *  shows "CRASHED" with the bust provocation (post the L, on-brand with wheel). */
export function buildCrashCard(handle: string, result: CrashResult): CardProps {
  if (result.won) {
    // Display the cashed multiplier (always present on a win); value is the ×100 form.
    const mult = result.multiplier ?? (result.value ?? 0) / 100;
    const seed = result.value ?? Math.round(mult * 100);
    const props: CardProps = {
      game: "crash",
      display: `${mult.toFixed(2)}x`,
      handle,
      provocation: crashProvocation(seed),
      date: today(),
    };
    if (
      result.total !== undefined &&
      result.percentile !== undefined &&
      result.total >= RANKLINE_MIN_TOTAL
    ) {
      return { ...props, rankLine: `top ${result.percentile}% crash` };
    }
    return props;
  }

  // Crashed — seed the provocation on the crash point so it's deterministic.
  const seed = Math.round(result.crashPoint * 100);
  return {
    game: "crash",
    display: "CRASHED",
    handle,
    provocation: crashBustProvocation(seed),
    date: today(),
  };
}

function today(): string {
  return new Date().toISOString().slice(0, 10);
}
